module.exports = __webpack_public_path__ + "static/media/empty.f52b89f0.svg";